import React from "react";
import ExternalArrow from "../../../common/external-arrow";
import LinkText from "../../../common/link-text";
import {
  FooterItem,
  FooterLeft,
  FooterRight,
  FooterSectionContainer,
  FooterSectionContent,
} from "./style";

const footerItems = [
  {
    name: "Linkedin",
    url: "https://www.linkedin.com/in/freddyas/",
    margin: {},
  },
  {
    name: "Medium",
    url: "https://fide11s.medium.com",
    margin: {},
  },
  {
    name: "Email",
    url: "mailto:freddy11sanjaya@gmail.com",
    margin: {
      right: "0px",
    },
  },
];

const renderItems = () =>
  footerItems.map((footer) => (
    <FooterItem key={footer.name}>
      <LinkText
        url={footer.url}
        label={
          <>
            {footer.name} <ExternalArrow />
          </>
        }
      />
    </FooterItem>
  ));

const logoMargin = {
  left: 0,
  right: 0,
};

const FooterSection = () => (
  <FooterSectionContainer>
    <FooterSectionContent>
      <FooterLeft>
        <FooterItem margin={logoMargin}>
          © {new Date().getFullYear()} Freddy Albert Sanjaya
        </FooterItem>
      </FooterLeft>
      <FooterRight>{renderItems()}</FooterRight>
    </FooterSectionContent>
  </FooterSectionContainer>
);

export default FooterSection;
